import { renderAiUsageBadge, readLabelsFromContainer, AiUsage } from '../ai/ai-usage-badge';

interface RankedOffer {
    offerId: number;
    score: number;
    rationale: string;
}

interface ProposalData {
    proposal: {
        accommodation: RankedOffer[];
        transport: RankedOffer[];
        insurance: RankedOffer[];
        rationale: string;
    };
    usage?: unknown;
}

export function initAiPropose(form: HTMLFormElement) {
    const proposeBtn = document.getElementById('ai-propose-btn');
    const proposeInput = document.getElementById('ai-propose-input') as HTMLTextAreaElement | null;
    const proposeResult = document.getElementById('ai-propose-result');
    const urlAiPropose = form.dataset.urlAiPropose || '';
    const labels = readLabelsFromContainer(form);

    if (!proposeBtn || !proposeInput || !proposeResult || !urlAiPropose) return;

    proposeBtn.addEventListener('click', async () => {
        const brief = proposeInput.value.trim();
        if (!brief) return;

        const agencySelect = document.getElementById('AgencyId') as HTMLSelectElement | null;
        const agencyId = agencySelect?.value || '0';

        proposeBtn.setAttribute('disabled', '');
        proposeResult.innerHTML = '...';

        try {
            const token = document.querySelector<HTMLInputElement>('input[name="__RequestVerificationToken"]')?.value ?? '';
            const resp = await fetch(`${urlAiPropose}?agencyId=${agencyId}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'RequestVerificationToken': token },
                body: JSON.stringify({ customerBrief: brief })
            });
            const json = await resp.json();

            if (!json.success) {
                proposeResult.textContent = json.message ?? 'AI proposal failed.';
                return;
            }

            const data: ProposalData = json.data;
            const proposal = data.proposal;
            applyProposal('AccommodationOfferIds', proposal.accommodation);
            applyProposal('TransportOfferIds', proposal.transport);
            applyProposal('InsuranceOfferIds', proposal.insurance);

            const total = proposal.accommodation.length + proposal.transport.length + proposal.insurance.length;
            const resultText = total > 0
                ? `✨ ${total} offer(s) pre-selected. ${proposal.rationale}`
                : 'No matching offers found for this brief.';

            proposeResult.innerHTML = resultText;
            if (json.usage) {
                proposeResult.insertAdjacentHTML('beforeend', renderAiUsageBadge(json.usage as AiUsage, labels));
            }
        } catch {
            proposeResult.textContent = 'AI proposal failed. Please try again.';
        } finally {
            proposeBtn.removeAttribute('disabled');
        }
    });
}

function applyProposal(selectId: string, offers: RankedOffer[]) {
    const sel = document.getElementById(selectId) as HTMLSelectElement | null;
    if (!sel || !offers.length) return;

    // Deselect all first
    Array.from(sel.options).forEach(opt => (opt.selected = false));

    // Select proposed offers
    offers.forEach(r => {
        const opt = Array.from(sel.options).find(o => o.value === String(r.offerId));
        if (opt) opt.selected = true;
    });

    // Trigger change so price calculator and other listeners update
    sel.dispatchEvent(new Event('change', { bubbles: true }));
}
